const styles = theme => ({
  root: {
    margin: '50px 0',
  },
  logo: {
    margin: '25px 0',
    textAlign: 'center',
  },
  logoImg: {
    width: 150,
  },
  container: {
    maxWidth: 460,
    margin: '0 auto',
    padding: '35px 0',
    position: 'relative',
    overflowX: 'hidden',
  },
  backButton: {
    position: 'absolute',
    top: 0,
  },
  step: {
    padding: '25px 35px 0 35px',
    overflow: 'hidden',
  },
  textField: {
    width: '100%',
  },
  buttonContainer: {
    textAlign: 'right',
  },
  buttonWrapper: {
    position: 'relative',
    display: 'inline-flex',
  },
  buttonProgress: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  error: {
    color: 'red',
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/sections/recover/styles.js